import { createInterceptorCondition, INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG, IncludeBearerTokenCondition, KEYCLOAK_EVENT_SIGNAL, KeycloakEventType, provideKeycloak } from 'keycloak-angular';
import { inject, provideAppInitializer } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

import { filter, firstValueFrom, switchMap } from 'rxjs';

import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../services/authentication.service';

const urlCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern: new RegExp(`^(${environment.api})(/.*)?$`, 'i'),
  bearerPrefix: 'Bearer'
});

export const provideKeycloakAngular = () =>
  provideKeycloak({
    config: {
      url: environment.keycloak.url,
      realm: environment.keycloak.realm,
      clientId: environment.keycloak.clientId
    },
    initOptions: {
      onLoad: 'login-required',
      enableLogging: environment.production
    },
    providers: [
      {
        provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
        useValue: [urlCondition]
      },
      provideAppInitializer(() => {
        const keycloakSignal = inject(KEYCLOAK_EVENT_SIGNAL);
        const authenticationService = inject(AuthenticationService);

        return firstValueFrom(
          toObservable(keycloakSignal).pipe(
            filter((event) => event.type === KeycloakEventType.Ready && event.args === true),
            switchMap(() => authenticationService.getUser())
          )
        );
      })
    ],
  });
